import { useEffect, useState } from "react";

/**
 * هوك للعد التنازلي. يحدث كل ثانية ويرجع الأيام/الساعات/الدقائق/الثواني وdiff (مللي ثانية).
 * يضمن ألا تظهر أرقام سالبة (يقف عند 0).
 */
export function useCountdown(targetIsoOrTs) {
  const target =
    typeof targetIsoOrTs === "string"
      ? new Date(targetIsoOrTs).getTime()
      : Number(targetIsoOrTs);

  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!target || Number.isNaN(target)) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [target]);

  const diff = Math.max(0, target - now);
  const days = Math.floor(diff / 86_400_000);
  const hours = Math.floor((diff % 86_400_000) / 3_600_000);
  const minutes = Math.floor((diff % 3_600_000) / 60_000);
  const seconds = Math.floor((diff % 60_000) / 1000);

  return { days, hours, minutes, seconds, diff, expired: diff === 0 };
}
